import {ClipboardEvent, FC, useEffect, useRef, useState} from 'react'
import {FormControl, FormLabel, Input as ChakraInput, InputGroup, InputRightElement, Text,} from '@chakra-ui/react'
import {useFormContext} from 'react-hook-form'
import {get} from 'lodash-es'
import FormErrorMessage from '_app/components/Form/FormErrorMessage'

const InputWithCounter: any = ({
  label,
  name,
  type = 'text',
  isRequired,
  hidden,
  isDisabled,
  mb = 4,
  length,
  persist = false,
  maxCharacters,
  disablePasting = false,
  onChange,
  ...props
}) => {
  const ref = useRef()
  const {
    register,
    formState: { errors },
    unregister,
    watch,
  } = useFormContext()
  const [inputLength, setInputLength] = useState(length || watch(name)?.length || 0)
  const errorMessage = get(errors, name)?.message
  useEffect(() => {
    return () => {
      if (!persist) unregister(name)
    }
  }, [unregister, name, persist])
  useEffect(() => {
    if (typeof length === 'number') {
      setInputLength(length)
    }
  }, [length])
  return (
    <FormControl
      isRequired={isRequired && !hidden && !isDisabled}
      isInvalid={!!errorMessage}
      mb={mb}
    >
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <InputGroup>
        <ChakraInput
          type={type}
          p={0}
          borderColor={errorMessage ? 'alert' : 'black'}
          {...register(name)}
          data-testid={name}
          hidden={hidden}
          onChange={onChange}
          isDisabled={isDisabled}
          _placeholder={{ color: 'black', opacity: 0.4 }}
          required={false}
          maxLength={maxCharacters || undefined}
          paddingRight={maxCharacters ? '3rem' : undefined}
          onPaste={
            disablePasting
              ? (e: ClipboardEvent<HTMLInputElement>) => {
                  e.preventDefault()

                  return false
                }
              : undefined
          }
          {...props}
        />
        <InputRightElement zIndex={0}>
          {maxCharacters && (
            <Text fontSize={12} opacity={0.8}>
              {inputLength} / {maxCharacters}
            </Text>
          )}
        </InputRightElement>
      </InputGroup>
      <FormErrorMessage name={label}>{errorMessage}</FormErrorMessage>
    </FormControl>
  )
}

export default InputWithCounter
